let fileInfo = {
  result: 0,
  desc: "successful",
  content: {
    fileList: [
      {
        name: "AI创新与供应链经济协同-演进及投资逻辑.docx",
        type: "doc",
      },
      {
        name: "AI创新与供应链经济协同-演进及投资逻辑.docx",
        type: "doc",
      },
      {
        name: "AI创新与供应链经济协同-演进及投资逻辑.docx",
        type: "doc",
      },
      {
        name: "AI创新与供应链经济协同-演进及投资逻辑.docx",
        type: "doc",
      },
    ],
    folderList: [
      {
        id: 1,
        name: "报名资料",
        fileList: [],
      },
      {
        id: 2,
        name: "演讲资料",
        fileList: [],
      },
    ],
  },
};
export default fileInfo;
